import { AfterViewInit, Component, Input } from '@angular/core';

@Component({
  selector: 'app-hotel-menutab',
  templateUrl: './hotel-menutab.component.html',
  styleUrls: ['./hotel-menutab.component.css']
})
export class HotelMenutabComponent implements AfterViewInit {
  @Input() isEdit: boolean = false;
  @Input() nameMenu: string = '';
  @Input() branchofficeSlug: string = '';
  @Input() checkId: any = '';

  constructor() {}

  ngAfterViewInit(): void {}
}
